export default __webpack_public_path__ + "static/media/compra-27.9d8b8cbf.svg";